import PropTypes from 'prop-types';
import { Grid, Card, CardContent, Stack, Box, Typography } from '@mui/material';
import { ReceiptLongOutlined, AccountBalanceWalletOutlined, CheckCircleOutline, AssessmentOutlined } from '@mui/icons-material';
import { formatINR } from '../credit-limits/creditLimitsUtils';

const TransactionHistoryStats = ({ stats }) => {
    return (
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
            {/* Total Transactions */}
            <Grid item xs={12} sm={6} md={3}>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                        bgcolor: '#fff'
                    }}
                >
                    <CardContent sx={{ p: 2.5 }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                                    Total Transactions
                                </Typography>
                                <Typography variant="h4" fontWeight={800} color="text.primary" sx={{ mt: 0.5 }}>
                                    {(stats?.count || 0).toLocaleString()}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: 2.5,
                                    bgcolor: '#eff6ff',
                                    color: '#1d4ed8'
                                }}
                            >
                                <ReceiptLongOutlined />
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>

            {/* Total Settled Amount */}
            <Grid item xs={12} sm={6} md={3}>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                        bgcolor: '#fff'
                    }}
                >
                    <CardContent sx={{ p: 2.5 }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                                    Total Settled Amount
                                </Typography>
                                <Typography variant="h4" fontWeight={800} color="text.primary" sx={{ mt: 0.5 }}>
                                    {formatINR(stats?.totalAmount || 0)}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: 2.5,
                                    bgcolor: '#f0fdf4',
                                    color: '#15803d'
                                }}
                            >
                                <AccountBalanceWalletOutlined />
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>

            {/* Successful Settlements */}
            <Grid item xs={12} sm={6} md={3}>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                        bgcolor: '#fff'
                    }}
                >
                    <CardContent sx={{ p: 2.5 }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                                    Successful
                                </Typography>
                                <Typography variant="h4" fontWeight={800} color="#15803d" sx={{ mt: 0.5 }}>
                                    {stats?.successCount || 0}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: 2.5,
                                    bgcolor: '#f0fdf4',
                                    color: '#15803d'
                                }}
                            >
                                <CheckCircleOutline />
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>

            {/* Unique Accounts */}
            <Grid item xs={12} sm={6} md={3}>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.04)',
                        bgcolor: '#fff'
                    }}
                >
                    <CardContent sx={{ p: 2.5 }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase">
                                    Unique Accounts
                                </Typography>
                                <Typography variant="h4" fontWeight={800} color="#1e40af" sx={{ mt: 0.5 }}>
                                    {stats?.uniqueAccounts || 0}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: 2.5,
                                    bgcolor: '#eff6ff',
                                    color: '#1d4ed8'
                                }}
                            >
                                <AssessmentOutlined />
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

TransactionHistoryStats.propTypes = {
    stats: PropTypes.shape({
        count: PropTypes.number,
        totalAmount: PropTypes.number,
        successCount: PropTypes.number,
        uniqueAccounts: PropTypes.number
    }).isRequired
};

export default TransactionHistoryStats;
